import { NgModule, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductComponent } from './product/product.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgbCarouselModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { WhishlistComponent } from './whishlist/whishlist.component';
import {MatBadgeModule} from '@angular/material/badge';
import {AppCommonModule} from '../common/common.module';



@NgModule({
  declarations: [
    ProductComponent,
    WhishlistComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbCarouselModule,
    NgbRatingModule,
    MatBadgeModule,
    AppCommonModule
  ]
})
export class ProductModule { }
